module.exports = __webpack_public_path__ + "static/media/right.05776c1c.svg";